import styled from "styled-components";
import {LiveCasinoNavbarDefaultBox} from "./live-casino-navbar.default.box";

export const LiveCasinoNavbarCipBox = styled(LiveCasinoNavbarDefaultBox)`
  background: ${props => props.theme.colors.backgroundDark};
`;
